// extracted by mini-css-extract-plugin
export default {"topbtn":"scroll_topbtn__dqHxs","icon":"scroll_icon__XPAtR","gototop":"scroll_gototop__06AqZ"};